import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6782a0d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = ["content"]
const _hoisted_4 = {
  style: {"--bs-breadcrumb-divider":"'•'"},
  "aria-label": "breadcrumb"
}
const _hoisted_5 = { class: "breadcrumb mb-0" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-xl-8 col-lg-12" }
const _hoisted_10 = { class: "col-xl-4 col-lg-12 ps-xl-2" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col pt-5" }
const _hoisted_13 = { class: "text-justify" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CategoryBoxesComponent = _resolveComponent("CategoryBoxesComponent")!
  const _component_MainHeaderComponent = _resolveComponent("MainHeaderComponent")!
  const _component_MainCardsComponent = _resolveComponent("MainCardsComponent")!
  const _component_SortHeaderComp = _resolveComponent("SortHeaderComp")!
  const _component_CatalogCardsComp = _resolveComponent("CatalogCardsComp")!
  const _component_NoveltiesCardsComponent = _resolveComponent("NoveltiesCardsComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString(_ctx.metaTitle), 1),
        _createElementVNode("meta", {
          name: "description",
          content: _ctx.metaDesc
        }, null, 8, _hoisted_1),
        _createElementVNode("meta", {
          property: "og:title",
          content: _ctx.metaTitle
        }, null, 8, _hoisted_2),
        _createElementVNode("meta", {
          property: "og:description",
          content: _ctx.metaDesc
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }),
    _createElementVNode("nav", _hoisted_4, [
      _createElementVNode("ol", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode("Главная")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.getPrettyGame(this.game)), 1)
      ])
    ]),
    _createVNode(_component_CategoryBoxesComponent),
    _createVNode(_component_MainHeaderComponent, { title: "Популярное" }),
    _createVNode(_component_MainCardsComponent),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_SortHeaderComp, {
          title: "Каталог",
          onApplySortByParam: _ctx.applySortByParam
        }, null, 8, ["onApplySortByParam"]),
        _createVNode(_component_CatalogCardsComp)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_MainHeaderComponent, { title: "Новинки" }),
        _createVNode(_component_NoveltiesCardsComponent)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, [
          _createTextVNode("Моды значительно расширяют возможности " + _toDisplayString(_ctx.getPrettyGame(this.game)) + ": новые автомобили, карты, сценарии, визуальные улучшения позволяют настроить игру под любые предпочтения. Сообщество моддеров регулярно публикует обновления и файлы, поддерживая разнообразие контента и долгую жизнь проекта. ", 1),
          _hoisted_14,
          _hoisted_15,
          _createTextVNode(" Если вы ищете моды, созданные фанатами, сайт mod-box.ru предоставит коллекцию пользовательских модификаций для " + _toDisplayString(_ctx.getPrettyGame(this.game)) + ". Наша платформа предлагает каждому пользователю огромное разнообразие различных модов игры " + _toDisplayString(_ctx.getPrettyGame(this.game)) + " для вашего удобства и удовольствия.", 1)
        ])
      ])
    ])
  ], 64))
}